import { createWebHistory, createRouter } from "vue-router";
import HomeLayout from "@/page/HomeLayout.vue";
import Login from "@/page/LoginLayout.vue";
import ProblemLayout from "@/page/ProblemLayout.vue";
import SolutionLayout from "@/page/SolutionLayout.vue";
import DataLayout from "@/page/DataLayout.vue";
import ServiceLayout from "@/page/ServiceLayout.vue";
import ShopLayout from "@/page/ShopLayout.vue";
import QuestionListLayout from "@/page/QuestionListLayout.vue";
import DownloadLayout from "@/page/DownloadLayout.vue";
import TipLayout from "@/page/TipLayout.vue";
import VideoLayout from "@/page/VideoLayout.vue";
import ServiceGuideLayout from "@/page/ServiceGuideLayout.vue";
import ServiceSubmitLayout from "@/page/ServiceSubmitLayout.vue";
import ServiceCheckLayout from "@/page/ServiceCheckLayout.vue";
import ServiceClassLayout from "@/page/ServiceClassLayout.vue";
import Afterservice from "@/page/Afterservice.vue";
import AddSolution from "@/page/AddSolution.vue";
import AddQna from "@/page/AddQna.vue";
import QuestionAnswer from "@/page/QuestionAnswer";
import VerifyProduct from "@/page/VerifyProduct";
import IntegratedSearch from "@/page/IntegratedSearch"
import NoticeList from "@/page/NoticeList"
import SignUpLayout from "@/page/SignUpLayout"
import PraiseListLayout from "@/page/PraiseListLayout"
import ComplainListLayout from "@/page/ComplainListLayout"
import Praise from "@/page/Praise"
import Complain from "@/page/Complain"
import AddPraise from "@/page/AddPraise"
import AddComplain from "@/page/AddComplain"
import FindID from "@/page/FindID"
import FindPassword from "@/page/FindPassword"
import ResetPassword from "@/page/ResetPassword"
import DownloadNotice from "@/page/DownloadNotice.vue"
import ProductLayout from "@/page/ProductLayout.vue"
import { useStore } from "vuex";

const routes = [
    { path: "/", redirect: "/home" },
    {
        path: "/home",
        name: "Home",
        component: HomeLayout,
    },
    {
        path: "/problem",
        name: "Problem",
        component: ProblemLayout,
        meta: {
            allowedCategories: [
                "GPS플로터",
                "레이더",
                "무선/통신장비",
                "항해 안전장비",
                "항해 조타장비",
                "해상용 안테나/헤딩센서",
                "선박용 인산철배터리",
                "선박용 전기관련 제품",
                "부품 및 액세서리",
            ],
        },
    },
    {
        path: "/solution/:id",
        name: "Solution",
        component: SolutionLayout,
        props: true,
    },
    {
        path: "/data",
        name: "Data",
        component: DataLayout,
        children: [
            {
                path: "download",
                component: DownloadLayout,
            }, {
                path: "download/notice/:id",
                name: "DownloadNotice",
                component: DownloadNotice,
                props: true,
            },
            {
                path: "tip",
                component: TipLayout,
            },
            {
                path: "video",
                component: VideoLayout,
            },
        ],
    },
    {
        path: "/service",
        name: "Service",
        component: ServiceLayout,
        children: [
            {
                path: "guide",
                component: ServiceGuideLayout,
            },
            {
                path: "submit",
                component: ServiceSubmitLayout,
            },
            {
                path: "check",
                component: ServiceCheckLayout,
            },
            {
                path: "lecture",
                component: ServiceClassLayout,
            },
        ],
    },
    {
        path: "/shop",
        name: "Shop",
        component: ShopLayout,
    },
    {
        path: "/customer",
        name: "Customer",
        children: [
            {
                path: "qna",
                name: "QnaList",
                component: QuestionListLayout,
            },
            {
                path: "qna/:id",
                name: "Qna",
                component: QuestionAnswer,
                props: true,
            },
            {
                path: "verify/product",
                name: "VerifyProduct",
                component: VerifyProduct,
            },
            {
                path: "praise",
                name: "PraiseList",
                component: PraiseListLayout
            },
            {
                path: "praise/:id",
                name: "Praise",
                component: Praise,
                props:true
            },
            {
                path: "complain",
                name: "ComplainList",
                component: ComplainListLayout
            },
            {
                path: "complain:/id",
                name: "Complain",
                component: Complain,
                props:true
            }
        ],
    },

    {
        path: "/add",
        name: "Add",
        children: [
            {
                path: "solution",
                name: "AddSolution",
                component: AddSolution,
            },
            {
                path: "qna",
                name: "AddQna",
                component: AddQna,
            },
            {
                path: "praise",
                name: "AddPraise",
                component: AddPraise,
            },
            {
                path: "complain",
                name: "AddComplain",
                component: AddComplain,
            }
        ],
    },
    {
        path: "/product",
        name: "Product",
        component: ProductLayout
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/signup",
        name: "SignUp",
        component: SignUpLayout,
    },
    {
        path: "/find",
        children: [
            {
                path: "id",
                name: "FindID",
                component: FindID
            },{
                path: "password",
                name: "FindPassword",
                component: FindPassword
            },
        ]
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        component: ResetPassword,
        props: true
    },
    {
        path: "/as/",
        name: "Afterservice",
        component: Afterservice,
        props: true,
    },

    {
        path: "/search",
        name: "Search",
        component: IntegratedSearch,
        props:true,
    },
    {
        path: "/notice",
        name: "Notice",
        component: NoticeList
        
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});

router.beforeEach(async (to, from, next) => {
    if (to.matched.length === 0) {
        alert("잘못된 경로입니다");
        return ;
    }

    // problem 라우트에 대한 검사
    if (to.name === "Problem" && to.meta.allowedCategories) {
        const category = to.query.category;
        if (!to.meta.allowedCategories.includes(category)) {
            alert("잘못된 사이트 경로입니다.");
            return next({ name: "Home" }); // 홈으로 리다이렉트하거나 적절한 처리 수행
        }
    } else if (to.name == "AddQna") {
        const store = useStore();
        try {
            const userProfile = await store.dispatch("getUserProfile")
            if (userProfile.id == null) {
                alert("로그인이 필요합니다.")
                return router.back();
            }
        } catch(err) {
            console.log(err);
            alert("로그인이 필요합니다.")
            return router.back();
        }
    } 
    next(); // 검증 후 문제 없으면 네비게이션을 계속 진행
});

export default router;
